import axios from "axios";
import Api from "../config/api/axios.urlcontext.js"

export default class ArmonizacionContable {
  async getAvanceChiapas(url) {
    try {
        // console.log('getMenuRendicionCtas(url');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getDocumentosAprobadosConac(url) {
    try {
        // console.log('getMenuRendicionCtas(url');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getDocumentosPublicadosChiapas(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getResultadoEvaluacionesArmonizacionCont(url) {
    try {
        // console.log('getResultadoEvaluacionesArmonizacionCont(url');
        // console.log(Api.APP_URL_API+url)
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getResultadoEvaluaciones(url) {
    try {
        // console.log('getResultadoEvaluaciones(url');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }
  //*
  //*****************************************************************/
  //* ------------ -----FORMATOS CONAC -----------------------------//
  //*****************************************************************/
  //*
  async getInformacionConsolidada(url) {
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getProvisionesSalarialesEconomicas(url) {
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getOrganismosSubsidiadosAC(url) {
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getOrganismosSubsidiadosInforLeyDisciplinaFinanciera(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getAyudaCiudadania(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getAyudaCiudadaniaDisciplinaFinanciera(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getDeudaPublica(url) {
    try {
        // console.log('getMenuRendicionCtas(url');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getDeudaPublicaDisciplinaFinanciera(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getObligaciones(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getObligacionesDisciplinaFinanciera(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getMunicipios(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getMunicipiosDisciplinaFinanciera(url) {
    try {
        // console.log('getDocumentosPublicadosChiapas(url____');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

}
